<template>
  <z-link
    href="https://querobolsa.com.br/"
    class="the-header-brand"
  >
    <img
      class="the-header-brand__image"
      :src="$asset('/cdn/logotype-undergraduate-light.svg', { source: 'media-hub' })"
      alt="Logo da Quero Bolsa"
      width="154"
      height="24"
    >
  </z-link>
</template>

<script>
export default {
  name: 'TheHeaderBrand',
}
</script>

<style lang="scss" scoped>
.the-header-brand {
  align-items: center;
  display: flex;
}

.the-header-brand__image {
  max-height: var(--unit-0800);
}
</style>
